import { combineLoaders } from '@/lib/loader/combine-loader';
import { permissionsLoader } from '@/lib/loader/permission-loader';
import { lazy } from 'react';

const OpeningHourAndDatesPage = lazy(
  () => import('./pages/opening-hour-and-dates')
);

const ClosingDatesPage = lazy(() => import('./pages/closing-dates'));
const ClosingDatesFormPage = lazy(() => import('./pages/closing-dates/form'));

export const scheduleRoute = [
  {
    path: '/schedule/opening-hour-and-dates',
    Component: OpeningHourAndDatesPage,
    loader: combineLoaders(permissionsLoader),
  },

  {
    path: '/schedule/closing-dates',
    Component: ClosingDatesPage,
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/schedule/closing-dates/:level/form',
    Component: ClosingDatesFormPage,
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/schedule/closing-dates/:level/form/:id',
    Component: ClosingDatesFormPage,
    loader: combineLoaders(permissionsLoader),
  },
];
